/* eslint-disable unicorn/prevent-abbreviations */

import smartfield from './smartfield/e2e-smartfield.route';
import mf from './mf/e2e-mf.route';
import ktable from './ktable/e2e-ktable.route';

export default [
	smartfield,
	mf,
	ktable,
];
